import { GraphqlService } from "@/@modules/fseg/services/GraphqlService";

export class CountryCodeService {
  public static countries: {
    lookupCode: string;
    fRName: string;
    nLName: string;
  }[] = [];

  public static async getCountries(): Promise<void> {
    const countries = await GraphqlService.getCountries();
    if (countries.length > 0) {
      this.countries = countries;
    }
  }
}
